import '../styles/Skills.css';
import { TargetSkills } from './ui/TargetSkills.jsx';
import { TargetExtraSkills } from './ui/TargetExtraSkills.jsx';

import iconHtml from '../assets/html5.svg';
import iconCss from '../assets/css3.svg';
import iconJs from '../assets/javascript.svg';
import iconGit from '../assets/git.svg';
import iconReact from '../assets/react.svg';
import iconMySql from '../assets/mysql.svg';
import iconStyCom from '../assets/styled-components.svg';
import iconFigma from '../assets/figma.svg';
import iconWorkbench from '../assets/workbench.svg';
import iconTerminal from '../assets/terminal.svg';
import iconRouter from '../assets/router.svg';
import iconNet from '../assets/net.png';
import iconJava from '../assets/java.svg';
import iconSql from '../assets/sql.png';
import iconAndroid from '../assets/iconAndroid.svg';
import iconCordova from '../assets/iconCordova.png';
import iconPhp from '../assets/iconPhp.png';
import iconC from '../assets/iconC.png';
import iconFirebase from '../assets/iconFirebase.png';
import iconVue2 from '../assets/iconVue2.png';
import iconJira from '../assets/iconJira.png';
export function Skills(){
  return(
    <section id="skills" className="skills">
      <h3 className="title">Tecnologías que aplico</h3>
      <div className="skills-content">

        <div className="skills-target-content">
          <TargetSkills img={iconCss} name="CSS" />
          <TargetSkills img={iconJs} name="JavaScript" />
          <TargetSkills img={iconNet} name=". Net Core" />
          <TargetSkills img={iconReact} name="React.js" />
          <TargetSkills img={iconVue2} name="Vue.js" />
          <TargetSkills img={iconJava} name="Java" />
          <TargetSkills img={iconMySql} name="MySQL" />
        </div>

        <div className="extra-skills-content">
          <TargetExtraSkills img={iconGit} name="Git" />
          <TargetExtraSkills img={iconSql} name="" />
          <TargetExtraSkills img={iconRouter} name="React Router" />
          <TargetExtraSkills img={iconStyCom} name="Styled Components" />
          <TargetExtraSkills img={iconPhp} name="PHP" />
          <TargetExtraSkills img={iconFigma} name="Figma" />
          <TargetExtraSkills img={iconJira} name="" />
          <TargetExtraSkills img={iconHtml} name="HTML" />
          <TargetExtraSkills img={iconC} name="C Sharp" />
          <TargetExtraSkills img={iconAndroid} name="Android Studio" />    
          <TargetExtraSkills img={iconFirebase} name="" />         
          <TargetExtraSkills img={iconCordova} name="Apache Cordova" /> 
          <TargetExtraSkills img={iconWorkbench} name="MySQL Workbench" />          
          <TargetExtraSkills img={iconTerminal} name="Terminal" />
        </div>
        
      </div>
    </section>
  );
}